'use client';

import { useRef } from 'react';
import Link from 'next/link';
import { motion, useInView } from 'framer-motion';
import { fadeInUp, staggerContainer } from '@/lib/animations';
import type { PricingContent } from '@/lib/content-schema';

interface Props {
  content: PricingContent['hero'];
}

export function PricingPageHero({ content }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <section className="pt-32 md:pt-40 pb-12 md:pb-16 bg-gradient-to-br from-zibarit-gris-oscuro to-zibarit-verde-oscuro">
      <motion.div
        ref={ref}
        variants={staggerContainer}
        initial="initial"
        animate={isInView ? 'animate' : 'initial'}
        className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
      >
        <motion.div variants={fadeInUp} className="mb-6">
          <Link
            href="/organizadores"
            className="text-body text-sm text-zibarit-bone/60 hover:text-zibarit-bone transition-colors inline-flex items-center gap-1.5"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="mt-px">
              <path d="M10 3l-5 5 5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {content.backText}
          </Link>
        </motion.div>
        <motion.p variants={fadeInUp} className="text-subtitle text-xs tracking-[0.2em] text-zibarit-verde-brillante mb-4">
          {content.subtitle}
        </motion.p>
        <motion.h1 variants={fadeInUp} className="text-title text-4xl md:text-5xl lg:text-6xl text-zibarit-bone">
          {content.title}
        </motion.h1>
        <motion.p variants={fadeInUp} className="text-body text-base md:text-lg text-zibarit-bone/70 mt-6 max-w-2xl mx-auto">
          {content.description}
        </motion.p>
      </motion.div>
    </section>
  );
}
